import grapesjs from 'drapcode-builder';
import loadComponents from './components';

const pluginConfig = (editor, opts = {}) => {
  let c = opts;

  const default_types = {
    register_totp: 'register-totp',
    verify_totp: 'verify-totp',
  };
  const default_labels = {
    register_totp: 'Register Two Factor Authentication',
    verify_totp: 'Verify Two Factor Authentication',
  };
  const options = {
    ...{
      labels: default_labels,
      types: default_types,
      labelTOTPCategory: '2F Authentication',
    },
    ...opts,
  };
  for (let name in options) {
    if (!(name in c)) c[name] = options[name];
  }
  loadComponents(editor, opts);
};

export default grapesjs.plugins.add('totp', pluginConfig);
